// extracted by mini-css-extract-plugin
module.exports = {"articles":"articles-module--articles--1B8lA"};